import { Icon } from "@iconify/react";
import Dashboard from "./Dashboard";
import LocationUsers from "./users";
import Devices from "./Devices";
import Settings from "./Settings";
import PhoneNumbers from "./PhoneNumbers";
import MessageLogs from "./MessageLogs";
import BalanceLogs from "./BalanceLogs";
import BulkMessages from "./bulkMessages";
import Support from "./Support";
import { SocketProvider } from "../../context/socket";
const routes = [
  {
    title: "Dashboard",
    icon: (
      <Icon icon="material-symbols:dashboard-outline" className="menu-icon" />
    ),
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    icon: <Icon icon="mdi:account-group-outline" className="menu-icon" />,
    title: "Users",
    key: "users",
    route: "/users",
    component: <LocationUsers />,
  },
  {
    icon: <Icon icon="mdi:devices" className="menu-icon" />,
    title: "Devices",
    key: "devices",
    route: "/devices",
    component: <Devices />,
  },
  {
    icon: (
      <Icon
        icon="material-symbols:phone-android-outline"
        className="menu-icon"
      />
    ),
    title: "Phone Numbers",
    key: "phone_numbers",
    route: "/phone-numbers",
    component: <PhoneNumbers />,
  },
  {
    icon: <Icon icon="mdi:message-text-outline" className="menu-icon" />,
    title: "Message Logs",
    key: "message_logs",
    route: "/message-logs",
    component: <MessageLogs />,
  },
  {
    icon: <Icon icon="mdi:message-text-outline" className="menu-icon" />,
    title: "Balance Logs",
    key: "balance_logs",
    route: "/balance-logs",
    component: <BalanceLogs />,
  },
  {
    icon: <Icon icon="material-symbols:speaker-notes" className="menu-icon" />,
    title: "Bulk Messages",
    key: "bulk_messages",
    route: "/bulk_messages",
    component: <BulkMessages />,
  },
  // {
  //   icon: <Icon icon="mdi:cog-outline" className="menu-icon" />,
  //   title: "Settings",
  //   key: "settings",
  //   route: "/settings",
  //   component: <Settings />,
  // },
  {
    icon: <Icon icon="mdi:headset" className="menu-icon" />,
    title: "Support",
    key: "support",
    route: "/support",
    component: (
      <SocketProvider>
        <Support />
      </SocketProvider>
    ),
  },
];

export default routes;
